import { FormControl, InputLabel } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import ReactSelect from "react-select"

const Selecao = (props) => {
	const {
		proriedadesPersonalizadas,
		retornarObjetoCompleto,
		mensagemSemOpcoes,
		abrirMenuAoFocar,
		desativarCampo,
		getOptionValue,
		getOptionLabel,
		maxHeightMenu,
		removerTitulo,
		handleChange,
		isClearable,
		autoFocus,
		tipoItem,
		etiqueta,
		isMulti,
		onFocus,
		opcoes,
		onBlur,
		codigo,
		error,
		modal,
		id,
		// scrollTable,
	} = props

	const classes = useStyles({ desativarCampo })
	const valor = (codigo || codigo === 0) && Array.isArray(opcoes) ? opcoes.filter((o) => o.codigo === codigo) : null

	const [campoSelecionado, setCampoSelecionado] = useState(null)
	const [titulo, setTitulo] = useState(false)

	useEffect(() => {
		removerTitulo && removerTitulo === true ? setTitulo(false) : setTitulo(true)
	}, [removerTitulo])

	const handleSelectOption = (option) => {
		handleChange(tipoItem, retornarObjetoCompleto ? option : option.codigo)
	}

	const handleOnBlur = () => {
		setCampoSelecionado(false)
		if (onBlur) onBlur();
	}

	const handleOnFocus = () => {
		setCampoSelecionado(true)
		if (onFocus) onFocus();
	}

	// useEffect(() => {
	// 	if (scrollTable) setCampoSelecionado(false)
	// }, [scrollTable])

	const selectStyles = estilos(error, maxHeightMenu, campoSelecionado, desativarCampo, removerTitulo)

	return (
		<FormControl id="form" variant="outlined" className={classes.input}>
			{titulo
				? (campoSelecionado || (codigo || codigo === 0)) && (
					<InputLabel
						style={{
							color:
								error && !desativarCampo
									? "#f44336"
									: campoSelecionado && !desativarCampo
										? "#BF43AB"
										: "#61688B",
							// backgroundImage: desativarCampo
							// 	? "linear-gradient(180deg, transparent 50%, hsl(0,0%,95%) 50%)"
							// 	: "none",
						}}
						className={classes.labelFlutuante}
						htmlFor="outlined-age-native-simple"
					>
						{etiqueta}
					</InputLabel>
				)
				: []}
			<ReactSelect
				menuPlacement={"auto"}
				noOptionsMessage={() => mensagemSemOpcoes}
				onBlur={handleOnBlur}
				onFocus={handleOnFocus}
				styles={selectStyles}
				menuPortalTarget={modal ? document.body : null}
				getOptionValue={getOptionValue}
				getOptionLabel={getOptionLabel}
				{...proriedadesPersonalizadas}
				onChange={handleSelectOption}
				placeholder={etiqueta}
				filterOption={props.filterOption}
				isDisabled={desativarCampo}
				isClearable={isClearable}
				isMulti={isMulti}
				className={classes.input}
				autoFocus={autoFocus}
				options={opcoes}
				openMenuOnFocus={abrirMenuAoFocar}
				tabSelectsValue
				value={valor && valor.length > 1 ? valor.map(item => item.descricao).join(', ') : valor}
				id={id}
				components={{
					IndicatorSeparator: () => null,
				}}
			// closeMenuOnScroll={(e) => scrollTable && e.target}
			// menuPlacement={"top"}
			/>
			{error && <span className={classes.mensagemErro}>{error}</span>}
		</FormControl>
	)
}

const corPlaceholder = (erro, isFocused) => {
	if (erro && !isFocused) return "#f44336"

	if (isFocused) return "rgba(0, 0, 0, 0)"

	return "#61688B"
}

const estilos = (error, maxHeight, focus, desativarCampo, removerTitulo) => ({
	menuList: (styles) => ({
		...styles,
		maxHeight: 220,
		padding: "0px 0px !important",
		borderRadius: "5px",
		boxShadow: "0 1px 0 2px rgba(192,192,222,0.3)",
		"&::-webkit-scrollbar": {
			width: "8px",
			height: "8px",
			cursor: "pointer",
		},
		"&::-webkit-scrollbar-track": {
			background: "#f1f1f1",
		},
		"&::-webkit-scrollbar-thumb": {
			background: "rgba(0, 0, 0, 0.2)",
			borderRadius: "10px",
		},
	}),
	menuPortal: (styles) => ({
		...styles,
		zIndex: 99999,
	}),
	menu: (styles) => ({ ...styles, zIndex: 99999 }),
	indicatorContainer: (styles) => ({
		...styles,
		padding: "10px",
		backgroundColor: "#BF43AB",
		color: desativarCampo ? null : "#61688B",
	}),
	input: (provided) => ({
		...provided,
		paddingTop: "12px",
		paddingBottom: "12px",
		width: "100%",
		fontFamily: "CircularStd-Book",
		fontSize: "1rem",
		position: "relative",
	}),
	singleValue: (provided) => ({
		...provided,
		fontSize: "1rem",
		color: "#23144D"
	}),
	placeholder: (provided) => ({
		...provided,
		fontFamily: "CircularStd-Book",
		fontSize: "1rem",
		color: corPlaceholder(error, focus),
	}),
	control: (styles, { isFocused }) => ({
		...styles,
		":hover": {
			borderColor: error ? "#f44336" : isFocused ? "#BF43AB" : "#23144D",
		},
		boxShadow: isFocused ? `0 1 0 1px ${"#BF43AB"}` : "none",
		borderColor: error ? "#f44336" : isFocused ? "#BF43AB" : "#C0C0DE",
		backgroundColor: desativarCampo ? "#ECECF5" : "#FFFFFF",
		padding: "0px 8px",
		width: removerTitulo ? "114%" : null,
	}),
	option: (styles, { isDisabled, isFocused, isSelected }) => {
		return {
			...styles,
			backgroundColor: isFocused ? "rgba(192, 192, 222, 0.3)" : "#FFFFFF",
			cursor: "pointer",
			color: "#61688B",
			fontSize: "1rem",
			boxShadow: "0px 0px 1px 1px rgba(192,192,222,0.3)",
			":active": {
				...styles[":active"],
				backgroundColor: "#FFFFFF",
			},
			":hover": {
				...styles[":hover"],
				backgroundColor: "rgba(192, 192, 222, 0.3)",
			},
			padding: "15px 15px",
		}
	},
})

const useStyles = makeStyles({
	input: {
		width: "100%",
		maxHeight: "100px",
	},
	disabled: {
		backgroundColor: "rgb(242, 242, 242)",
		borderColor: "rgb(230, 230, 230)",
	},
	labelFlutuante: ({ desativarCampo }) => ({
		background: desativarCampo ? "linear-gradient(180deg, rgba(255,255,255,1) 50%, rgba(236,236,245,1) 50%)" : "#FFFFFF",
		borderRadius: "8px",
		transform: "scale(0.75)",
		padding: "0 8px 0 8px",
		position: "absolute",
		fontSize: "1rem",
		lineHeight: "1",
		height: "16px",
		top: "-6px",
		left: "6px",
	}),
	mensagemErro: {
		margin: "4px 0px 0px 8px",
		color: "#f44336"
	},
})

Selecao.propTypes = {
	codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	proriedadesPersonalizadas: PropTypes.object,
	handleChange: PropTypes.func.isRequired,
	retornarObjetoCompleto: PropTypes.bool,
	tipoItem: PropTypes.string,
	mensagemSemOpcoes: PropTypes.string,
	maxHeightMenu: PropTypes.string,
	campoRequerido: PropTypes.bool,
	desativarCampo: PropTypes.bool,
	removerTitulo: PropTypes.bool,
	isClearable: PropTypes.bool,
	etiqueta: PropTypes.string,
	autoFocus: PropTypes.bool,
	opcoes: PropTypes.array,
	id: PropTypes.string,
	abrirMenuAoFocar: PropTypes.bool,
	filterOption: PropTypes.func,
	isMulti: PropTypes.bool,
	modal: PropTypes.bool,
}

Selecao.defaultProps = {
	mensagemSemOpcoes: "Sem opções",
	retornarObjetoCompleto: false,
	proriedadesPersonalizadas: {},
	campoRequerido: false,
	maxHeightMenu: "300px",
	desativarCampo: false,
	isClearable: false,
	autoFocus: false,
	etiqueta: "",
	codigo: null,
	opcoes: [],
	id: "",
	abrirMenuAoFocar: true,
	getOptionValue: (option) => option.codigo,
	getOptionLabel: (option) => {
		return option.codigo + " - " + option.descricao
	},
	filterOption: (option, text) =>
		option.label
			.toString()
			.toUpperCase()
			.includes(text.toUpperCase()),
}

export default Selecao
